import { useCallback, useState } from "react";

export const useSidecar = <T extends Record<string, unknown>>(
  initialData: T,
) => {
  const [isSidecarOpen, setIsSidecarOpen] = useState(false);
  const [sidecarMetaData, setSidecarMetaData] = useState<T>(initialData);

  const closeSidecar = useCallback(() => {
    setIsSidecarOpen(false);
    setSidecarMetaData(initialData);
  }, [initialData]);

  const openAssetSidecar = useCallback((data: T) => {
    setSidecarMetaData(data);
    setIsSidecarOpen(true);
  }, []);

  return { isSidecarOpen, sidecarMetaData, closeSidecar, openAssetSidecar };
};
